export default __webpack_public_path__ + "static/media/home-banner-cn.894ab00c.webp";